<!--
 * @Descripttion: 任务管理
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="task-mgmt-list">
    <div>
      <BaseTabs @tab-change="changePageType" v-model="pageType">
        <BaseTabPane label="任务记录" name="taskRecord"></BaseTabPane>
        <BaseTabPane
          v-if="showActivity"
          label="活动列表"
          name="activity"
        ></BaseTabPane>
        <BaseTabPane label="任务汇总" name="taskSummary"></BaseTabPane>
      </BaseTabs>
      <TaskRecordList v-if="pageType === 'taskRecord'"></TaskRecordList>
      <taskSummaryList v-if="pageType === 'taskSummary'"></taskSummaryList>
      <ActivityList v-if="pageType === 'activity'"></ActivityList>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import TaskRecordList from '../components/task-record-list.vue';
import ActivityList from '../components/activity-list.vue';
import taskSummaryList from '../components/task-summary-list.vue';

import { ref, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { useRoute, useRouter } from 'vue-router';
import { ProjectType } from '../types';

const route = useRoute();
const router = useRouter();
const pageType = ref(route.query.pageName || 'taskRecord');

const changePageType = () => {
  router.replace({
    query: { pageName: pageType.value, force: Date.now() }
  });
};

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const projectType = computed<ProjectType>(() => {
  return projectInfo.value.sceneType;
});
//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});

const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
const isActivity = ['1,1', '1,3'].includes(isEntry);
const showActivity = +projectType.value === 19 && isActivity;
</script>
<style lang="scss"></style>
